import {ArrowLeftBold, Plus} from "@element-plus/icons-vue";
import {
    getPatientList,
    getDocPatientProfile,
    getPatientListByName,
    getTreatItemList,
    addNewTreatOrder,
    saveDocPatientProfile,
    getTreatOrderItemList,
    executetreatOrderItem, getTreatOrderAllList, getTodayReservationList, getTodayReservationStat
} from '@/api'
import baseConfig from "@/api/config";
import {addDateRange, chackAlertMsg, getTodayDate, getCurrentDoctorId, message} from "@/assets/utils/common";
import {startReservationAutoRefresh, stopReservationAutoRefresh} from "@/assets/utils/reservationRefresh";

const RESERVATION_STATUS_OPTIONS = [
    {key: '', label: '全部', color: 'all'},
    {key: '5', label: '待就诊', color: 'pending'},
    {key: '2', label: '已就诊', color: 'visited'},
    {key: '7', label: '已过号', color: 'overdue'}
];

export default {
    computed: {
        baseConfig() {
            return baseConfig
        }
    },
    components: {
        ArrowLeftBold,
        Plus
    },
    props: {
        qorderId: "",
        qeditOrder: "",
        qagain: ""
    },
    data() {
        return {
            treatePage: "1",
            foldOrExpandPatient: true,
            chooseDppId: "",
            userInfo: null,
            patientCurrentPage: 1,
            patientPageNums: 40,
            patientQueryParams: {
                name: '',
            },
            queryBySearchBtn: false, // 是否通过搜索查询的
            patientList: [],
            patientActiveTab: 'today',
            reservationStatus: '5',
            reservationList: [],
            reservationLoading: false,
            reservationRefreshInFlight: false,
            reservationQuery: {cardPatientName: ''},
            reservationSearchTimer: null,
            reservationStats: RESERVATION_STATUS_OPTIONS.map(item => ({...item, count: 0})),
            reservationSelectedId: null,
            reservationRefreshTimer: null,
            reservationCurrentPage: 1,
            reservationPageSize: 40,
            reservationLastPage: false,
            patientCount: 20,
            patiantloading: false,
            loadDisabled: false,
            // 加载时的文本提示
            loadMoreStatus: "noMore",
            lastPage: false, // 是否是最后一页
            contentText: {
                contentdown: ' ',
                contentrefresh: '加载中',
                contentnomore: '没有更多数据了'
            },

            loading: false,
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            tableLoading: false,
            tableData: [],
            dateTime: [],
            tableHeight: 450,
            editBaseInfoVisible: false,
            addTreatVisible: false,

            treatLoading: false,
            treatOrderItem: {
                treatId: '',
            },
            treatItemData: [],

            patientInfoList: [],
            patientRange: [],
            patientSelectParams: {
                name: null
            },
            nameSelectConShow: false,
            tencentCosUrl: baseConfig.tencentCosUrl,
            payCodeList: [], // 预览的支付码
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },

            doctorInfo: {
                clinicDocPrice: null,
                clinicDocPriceRate: null,
                clinicDocPriceWay: "0",
                docFreeOpen: ""
            },
            treatOrderProjectName: [],
            treatOrder: {
                dateTime: null, // 就诊时间
                avatarImg: null, // 医生头像
                dppId: null, // 医生建档的患者ID
                dppName: null, // 患者姓名
                dppSex: null, // 患者性别
                dppAge: null, // 患者年龄
                dppPhone: null, // 患者手机号
                dppIdentity: null, // 患者身份证
                dppAddress: null, // 患者身地址
                dppAllergyHistory: null, // 患者过敏史
                docId: null, // 医生ID
                diagnosis: null, // 诊断
                projectType: null, // 诊疗项目
                projectName: null, // 项目类型
                treatPrice: null, // 金额
                orderPrice: null, // 实收
                treatOrderItemList: [], // 检查治疗项目订单对应子项目记录信息
                remark: null, // 备注
            },
            treatOrderParams:{
                projectType: null, // 诊疗项目
                diagnosis: null, // 诊断
            },

            treatmentItem: {
                itemType: null, // 项目类型
            },
            treatItemList: [],
            patientData: null, // 缓存中的患者相关信息
            openMore: false,
            treatOrderDetailVisible: false, // 检查治疗单详情弹窗
            printInfoObj: {
                id: 'printArea',
                popTitle: '知夏中医门诊部检查治疗单', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部检查治疗单', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {}, // 开启打印前的回调事件
                openCallback() {}, // 调用打印之后的回调事件
                closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
        }
    },
    created() {
        this.queryBySearchBtn = false;
        this.patientList = [];
        this.queryPatiantList(); // 默认查询患者列表
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.patientInfo.docId = this.doctorInfo.doctorId;
            this.treatOrder.docId = this.doctorInfo.doctorId;
            if (this.doctorInfo.clinicDocPrice === null || this.doctorInfo.clinicDocPrice === undefined || this.doctorInfo.clinicDocPrice === '') {
                this.doctorInfo.clinicDocPrice = "0";
            }
            if (this.doctorInfo.clinicDocPriceRate === null || this.doctorInfo.clinicDocPriceRate === undefined || this.doctorInfo.clinicDocPriceRate === '') {
                this.doctorInfo.clinicDocPriceRate = "0";
            }
        }
        this.queryTodayReservations();

    },
    mounted() {
        startReservationAutoRefresh(this, () => this.queryTodayReservations(true, false, true));
    },
    beforeUnmount() {
        stopReservationAutoRefresh(this);
    },
    methods: {

        switchPatientTab(tab) {
            this.patientActiveTab = tab;
            if (tab === 'today') {
                this.reservationCurrentPage = 1;
                this.reservationLastPage = false;
                this.reservationList = [];
                this.queryTodayReservations(true);
            }
        },

        switchReservationStatus(status) {
            this.reservationStatus = status;
            this.reservationCurrentPage = 1;
            this.reservationLastPage = false;
            this.reservationList = [];
            this.queryTodayReservations(true);
        },

        handleReservationSearchInput() {
            window.clearTimeout(this.reservationSearchTimer);
            this.reservationSearchTimer = window.setTimeout(() => {
                this.reservationCurrentPage = 1;
                this.reservationLastPage = false;
                this.reservationList = [];
                this.queryTodayReservations(false);
            }, 300);
        },

        loadMoreReservations() {
            if (this.reservationLoading || this.reservationLastPage) {
                return;
            }
            this.reservationCurrentPage++;
            this.queryTodayReservations(false, true);
        },

        queryTodayReservations(refreshStats = true, append = false, silent = false) {
            // 上一轮自动刷新尚未返回时跳过本轮，避免请求堆积
            if (silent && this.reservationRefreshInFlight) return;
            // 静默刷新不打扰当前浏览位置，仅手动操作时重置分页
            if (refreshStats && !append && !silent) {
                this.reservationCurrentPage = 1;
                this.reservationLastPage = false;
            }
            const doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo") || '{}');
            const baseParams = {
                schDate: getTodayDate(),
                doctorId: doctorInfo.doctorId || null,
                cardPatientName: this.reservationQuery.cardPatientName,
                pageNum: this.reservationCurrentPage,
                pageSize: this.reservationPageSize
            };
            if (!silent) {
                this.reservationLoading = true;
            }
            this.reservationRefreshInFlight = true;
            const loadList = () => getTodayReservationList({...baseParams, reStatus: this.reservationStatus, reStatusNot: '1,3,4', queueOrder: '1'})
                .then(response => {
                    const data = response.data || {};
                    const rows = data.code === 200 ? data.rows || [] : [];
                    this.reservationLastPage = rows.length < this.reservationPageSize;
                    this.reservationList = append ? this.reservationList.concat(rows) : rows;
                    this.reservationList.forEach(item => {
                        const birthYear = item.cardPatientBirth ? new Date(item.cardPatientBirth).getFullYear() : null;
                        item.age = item.age === undefined || item.age === null ? (birthYear ? new Date().getFullYear() - birthYear : '--') : item.age;
                    });
                })
                .catch(() => {
                    // 静默刷新失败保留现有列表，避免网络抖动清空面板
                    if (!silent) {
                        this.reservationList = [];
                    }
                })
                .finally(() => {
                    this.reservationLoading = false;
                    this.reservationRefreshInFlight = false;
                });
            if (!refreshStats) {
                loadList();
                return;
            }
            // 已通过"加载更多"翻页时，静默刷新只更新统计，不重置列表
            const statsOnly = silent && this.reservationCurrentPage > 1;
            // 单次聚合请求获取各状态统计
            getTodayReservationStat({schDate: baseParams.schDate, doctorId: baseParams.doctorId})
                .then(res => {
                    const rdata = res.data || {};
                    if (rdata.code === 200 && rdata.data) {
                        const d = rdata.data;
                        const statFieldMap = {'': 'total', '5': 'waitVisit', '2': 'done', '7': 'jumpCall'};
                        this.reservationStats.forEach(stat => {
                            const field = statFieldMap[stat.key];
                            if (field) stat.count = d[field] || 0;
                        });
                        // "全部"统计与列表口径一致：排除待支付/已失效/已取消（total 含全部状态，cancel=3+4，waitPay=1）
                        const totalStat = this.reservationStats.find(stat => stat.key === '');
                        if (totalStat) totalStat.count = (d.total || 0) - (d.cancel || 0) - (d.waitPay || 0);
                    }
                })
                .catch(() => {})
                .finally(() => {
                    if (statsOnly) {
                        this.reservationRefreshInFlight = false;
                    } else {
                        loadList();
                    }
                });
        },

        reservationStatusLabel(item) {
            const labels = {'1': '待支付', '2': '已完成', '3': '已失效', '4': '已取消', '5': '待就诊', '6': '就诊中', '7': '已过号', '8': '待签到'};
            return labels[String(item.reStatus)] || item.reStatusText || '未知';
        },

        reservationStatusKey(item) {
            const status = RESERVATION_STATUS_OPTIONS.find(option => option.key === String(item.reStatus));
            return status ? status.color : 'other';
        },

        reservationSex(sex) {
            return sex === '0' ? '男' : sex === '1' ? '女' : '未知';
        },

        isReservationSelected(item) {
            return this.reservationSelectedId === item.reId || (item.dppId && this.chooseDppId === item.dppId);
        },

        chooseReservationPatient(item) {
            this.reservationSelectedId = item.reId;
            // 修复：预约取号同样只匹配当前医生建的档案，避免关联到其他医生的dppId
            getPatientListByName({
                name: item.cardPatientName,
                identity: item.cardIdentity || '',
                docId: getCurrentDoctorId()
            }).then(response => {
                const rows = response.data && response.data.code === 200 ? response.data.rows || [] : [];
                const patient = rows.find(row => (item.cardIdentity && row.identity === item.cardIdentity) || (item.cardPatientPhone && row.phoneNumber === item.cardPatientPhone)) || rows[0];
                if (patient && patient.dppId) {
                    item.dppId = patient.dppId;
                    this.choosePatients(patient);
                } else {
                    this.patientInfo.name = item.cardPatientName;
                    this.patientInfo.sex = item.cardPatientSex;
                    this.patientInfo.age = item.age;
                    this.patientInfo.phoneNumber = item.cardPatientPhone;
                    this.patientInfo.identity = item.cardIdentity;
                }
            }).catch(() => {});
        },

        // 选择检查或治疗,获取检查治疗项目列表
        qryTreatmentProgramList() {
            this.treatItemList = [];
            this.treatOrderProjectName = null;
            this.treatmentItem.itemType = this.treatOrder.projectType;
            getTreatItemList(this.treatmentItem).then(response => {
                console.log(response);
                if (response.data.code === 200) {
                    this.treatItemList = response.data.rows;
                    this.treatItemList.forEach(item => {
                        item.isChoosed = false;
                    })
                }
            });
        },


        // 查看更多与收起
        showMore() {
            this.openMore = !this.openMore;
        },

        // 切换分页
        handleCurrentChange: function (val) {
            this.currentPage = val;
            this.getTreatHistoryOrderList();
        },

        // 切换分页
        handleSizeChange: function (val) {
            this.pageNums = val;
            this.getTreatHistoryOrderList();
        },



        // 关闭患者列表
        foldOrExpandPatientList() {
            this.foldOrExpandPatient = !this.foldOrExpandPatient;
        },

        //得到焦点选中
        focus(event) {
            event.currentTarget.select();
        },

        // 新增患者检查治疗
        addNewPatientTreat() {
            this.treatePage = "1";
            this.treatItemList = [];
            this.treatOrder.itemName = null;
            this.resetPatientPage(); // 重置患者信息页面
        },

        // 点击查询患者信息
        searchPatientList() {
            this.queryBySearchBtn = true;
            this.patientCurrentPage = 1;
            this.patientList = [];
            this.lastPage = false;
            this.loadDisabled = false;
            this.queryPatiantList();
        },

        // 获取近期患者列表
        queryPatiantList() {
            console.log(this.patientCurrentPage);
            if (this.patiantloading) {
                return;
            }
            this.patiantloading = true;
            this.patientQueryParams.pageNum = this.patientCurrentPage;
            this.patientQueryParams.pageSize = this.patientPageNums;
            getPatientList(this.patientQueryParams).then(response => {
                console.log(response);
                if (response.data.code === 200) {
                    this.loadMoreStatus = "more";
                    this.patientCount = response.data.total;
                    this.patiantloading = false;
                    // 将数据添加到列表中
                    console.log(response.data.rows.length);
                    if (response.data.rows.length > 0) {
                        if (response.data.rows.length < this.patientPageNums) {
                            this.lastPage = true;
                            this.loadDisabled = true;
                        }
                        this.patientList = this.patientList.concat(response.data.rows);
                    }
                    if (this.patientCurrentPage === 1 && this.queryBySearchBtn){
                        this.choosePatients(this.patientList[0]);
                    }
                    if (this.patientList.length > 0) {
                        this.patientList.forEach((item) => {
                            if (item.sex === '0') {
                                item.avatar = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                            } else if (item.sex === '1') {
                                item.avatar = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                            } else {
                                item.avatar = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                            }
                        })
                    }
                }
            }).finally(() => {
                this.patiantloading = false;
            });
        },

        // 加载更多
        loadMorePatient() {
            if (this.lastPage || this.patiantloading) {
                this.loadMoreStatus = "noMore";
            } else {
                this.loadMoreStatus = "loading";
                // 将页码+1
                this.patientCurrentPage++;
                this.queryPatiantList();
            }
        },


        // 通过患者姓名获取患者列表
        queryPatiantListByName(queryName) {
            if (queryName !== "" && queryName !== null && queryName !== undefined) {
                this.patientSelectParams.name = queryName;
                // 修复：/docPatientProfile/listAll 不会自动按医生过滤，必须显式传当前医生ID，否则会搜到其他医生的患者
                getPatientListByName({...this.patientSelectParams, docId: getCurrentDoctorId()}).then(response => {
                    this.patientInfoList = [];
                    this.patientRange = [];
                    if (response.data.code === 200) {
                        this.patientInfoList = response.data.rows;
                        if (this.patientInfoList.length > 0) {
                            this.nameSelectConShow = true;
                            this.patientInfoList.forEach(item => {
                                this.patientRange.push({
                                    dppId: item.dppId,
                                    name: item.name,
                                    identity: item.identity,
                                    isChoose: false,
                                });
                            })
                        } else {
                            this.nameSelectConShow = false;
                            this.resetPatientPage2(); // 重置患者信息页面
                        }
                        // console.log("patientRange >>>> " + JSON.stringify(this.patientRange));
                    } else {
                        this.nameSelectConShow = false;
                        this.resetPatientPage2(); // 重置患者信息页面
                    }
                });
            } else {
                this.nameSelectConShow = false;
                this.resetPatientPage2(); // 重置患者信息页面
            }
        },


        // 确定选择患者
        sureChoosePatient(dppId) {
            this.patientInfoList.forEach(item => {
                if (dppId === item.dppId) {
                    this.patientInfo.dppId = item.dppId;
                    this.choosePatients(item);
                }
            })
            this.patientRange.forEach(itm=>{
                itm.isChoose = dppId === itm.dppId;
            })
            this.nameSelectConShow = false;
        },


        // 选择患者
        choosePatients(itm) {
            if (this.chooseDppId !== "" && this.chooseDppId !== null && this.chooseDppId !== undefined) {
                if (this.chooseDppId !== itm.dppId) {
                    this.chooseDppId = itm.dppId;
                    this.dppId = itm.dppId;
                    this.treatOrder.dppId = this.dppId;
                    this.openPatientDetail(this.dppId);
                    this.treatePage = "2";
                    this.resizeTableHeight(); // 表格高度自适应
                } else {
                    this.patientInfo.dppId = "";
                    this.treatOrder.dppId = "";
                    this.resetPatientPage(); // 重置患者信息页面
                    this.treatePage = "1";
                }
            } else {
                this.chooseDppId = itm.dppId;
                this.dppId = itm.dppId;
                this.treatOrder.dppId = this.dppId;
                this.openPatientDetail(this.dppId);
                this.treatePage = "2";
                this.resizeTableHeight(); // 表格高度自适应
            }


        },

        // 选择时间
        chooseDateTime(){
            addDateRange(this.treatOrderParams, this.dateTime);
        },

        // 表格高度自适应
        resizeTableHeight() {
            setTimeout(()=>{
                if(this.$refs.multipleOrderTable){
                    this.$nextTick(() =>{
                        // 根据浏览器高度设置初始高度
                        this.tableHeight = window.innerHeight - this.$refs.multipleOrderTable.clientHeight - 44;
                        // 监听浏览器高度变化，修改表格高度
                        // window.onresize = () =>{
                        //     this.tableHeight = window.innerHeight - this.$refs.multipleOrderTable.clientHeight - 24;
                        // }
                    })
                }
            }, 100)
        },

        // 查看详情
        openPatientDetail(dppId) {
            this.dppId = dppId;
            this.qryPatientDetailInfo();// 查询患者详情
            this.getTreatHistoryOrderList(); // 查询检查治疗项目工单
        },


        // 查询详情
        qryPatientDetailInfo() {
            let data = {};
            getDocPatientProfile(this.dppId, data).then(response => {
                // console.log(response);
                if (response.data.code === 200) {
                    if (response.data.data !== null && response.data.data !== undefined) {
                        this.patientInfo = response.data.data;
                        this.casePic = this.patientInfo.casePic;
                        if (this.casePic !== null && this.casePic !== "" && this.casePic !== undefined) {
                            let casePicArr = this.casePic.split(",");
                            // console.log(casePicArr)
                            if (casePicArr.length > 0) {
                                this.casePicArray = [];
                                this.confileLists = [];
                                for (let i = 0; i < casePicArr.length; i++) {
                                    let casePicUrl = this.tencentCosUrl + casePicArr[i];
                                    // console.log("casePicUrl:"+casePicUrl)
                                    this.casePicArray.push(casePicUrl);
                                    var imageUrl = {"url": casePicUrl};
                                    this.confileLists.push(imageUrl);
                                }

                            } else {
                                this.casePicArray = [];
                                this.confileLists = [];
                            }
                        } else {
                            this.casePicArray = [];
                            this.confileLists = [];
                        }
                        // console.log("this.patientInfo.sex")
                        // console.log(this.patientInfo.sex)
                        if (this.patientInfo.sex === "1") {
                            this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else if (this.patientInfo.sex === "0") {
                            this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else {
                            this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                    } else {
                        this.casePicArray = [];
                        this.confileLists = [];
                    }
                }
            })
        },


        // 患者手机号输入后正则校验
        changePatientPhoneNumber() {
            var mobilePattern = /^1[3456789]\d{9}$/;
            if (!mobilePattern.test(this.patientInfo.phoneNumber)) {
                message("手机号码格式不正确！", "error");
            }
        },


        // 患者身份证信息输入后计算年龄
        changePatientIdentity() {
            let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
            let _IDre15 =  /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
            if(this.patientInfo.identity.length !== 18 && this.patientInfo.identity.length !== 15){
                message("身份证号码长度错误", "error");
            } else if( !_IDRe18.test(this.patientInfo.identity) && !_IDre15.test(this.patientInfo.identity )) {
                message("身份证号码格式不正确！", "error")
            } else {
                let year;
                if(this.patientInfo.identity.length === 18){
                    year = this.patientInfo.identity.substring(6).substring(0, 4);// 得到年份
                }else{
                    year = "19" + this.patientInfo.identity.substring(6, 8);// 年份
                }
                let nowYear = new Date().getFullYear();
                let age = parseInt(nowYear)-parseInt(year);
                console.log("age = " + age);
                this.patientInfo.age = age;
            }
        },


        // 修改患者基本信息
        editBaseInfo() {
            this.editBaseInfoVisible = !this.editBaseInfoVisible;
        },

        // 取消编辑患者基本信息
        cancelEditBaseInfo() {
            this.editBaseInfoVisible = false;
        },


        // 保存患者信息
        saveDocPateintProfileInfo(type) {
            var mobilePattern = /^1[3456789]\d{9}$/;
            let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
            let _IDre15 =  /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
            if (chackAlertMsg(this.patientInfo.docId, '患者未正确关联医师', 'error')
                && chackAlertMsg(this.patientInfo.name, '患者姓名不能为空', 'error')
                && chackAlertMsg(this.patientInfo.sex, '患者性别不能为空', 'error')
                && chackAlertMsg(this.patientInfo.phoneNumber, '患者联系电话不能为空', 'error')
                && chackAlertMsg(this.patientInfo.identity, '患者身份证不能为空', 'error')) {
                if (!mobilePattern.test(this.patientInfo.phoneNumber)) {
                    message("手机号码格式不正确！", "error")
                } else if (!_IDRe18.test(this.patientInfo.identity) && !_IDre15.test(this.patientInfo.identity)) {
                    message("身份证号码格式不正确！", "error")
                } else {
                    // addDocPatientProfile(this.patientInfo).then(response => {
                    saveDocPatientProfile(this.patientInfo).then(response => {
                        console.log(response);
                        if (response.code === 200) {
                            message("患者基本信息保存成功！", "success");
                            this.dppId = response.data;
                            this.patientInfo.dppId = response.data;
                            this.treatOrder.dppId = response.data;
                            if (type === 'edit') {
                                this.editBaseInfoVisible = false;
                            } else {
                                this.sureSaveTreatOrderFun();
                            }
                        } else {
                            message(response.msg, "error");
                        }
                    })
                }
            }
        },


        // 重置患者信息页面
        resetPatientPage() {
            this.chooseDppId = "";
            this.dppId = "";
            this.patientInfo.dppId = "";
            this.patientInfo.name = null;
            this.patientInfo.sex = null;
            this.patientInfo.phoneNumber = null;
            this.patientInfo.identity = null;
            this.patientInfo.province = null;
            this.patientInfo.height = null;
            this.patientInfo.weight = null;
            this.patientInfo.bloodType = null;
            this.patientInfo.patientType = null;
            this.patientInfo.marryStatus = null;
            this.patientInfo.occupation = null;
            this.patientInfo.allergyHistory = null;
            this.patientInfo.firstVisitResult = null;
        },

        // 搜索患者信息为空时，重置患者信息页面
        resetPatientPage2() {
            this.chooseDppId = "";
            this.dppId = "";
            this.patientInfo.dppId = "";
            this.patientInfo.sex = null;
            this.patientInfo.phoneNumber = null;
            this.patientInfo.identity = null;
            this.patientInfo.province = null;
            this.patientInfo.height = null;
            this.patientInfo.weight = null;
            this.patientInfo.bloodType = null;
            this.patientInfo.patientType = null;
            this.patientInfo.marryStatus = null;
            this.patientInfo.occupation = null;
            this.patientInfo.allergyHistory = null;
            this.patientInfo.firstVisitResult = null;
            this.patientInfo.remark = null;
        },

        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },


        // 执行检查治疗项目
        executetreatOrderItemFunc(itemId, toId, projectName) {
            this.$confirm('确定要执行当前所选项目吗？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                //根据工单类型筛选，已完成订单
                executetreatOrderItem(toId).then(response => {
                    console.log(response);
                    if (response.code === 200) {
                        message("所选的 " + projectName + " 项目执行成功！", "success");
                        this.qryryTreatItemList(itemId);
                    } else {
                        message("所选的 " + projectName + " 项目执行失败！原因：" + response.msg, "error");
                    }
                });
            }).catch(() => {
                console.log('用户取消切换');
            })
        },

        // 已执行提示
        executedFunc(projectName) {
            message("所选的 " + projectName + " 项目暂无法执行或已经执行完成，请核对后重试！", "warning");
        },


        // 查询检查治疗项目工单
        getTreatHistoryOrderList() {
            this.tableLoading = true;
            this.tableData = [];
            //根据工单类型筛选，已完成订单
            this.treatOrderParams.dppId = this.treatOrder.dppId;
            this.treatOrderParams.docId = this.treatOrder.docId;
            this.treatOrderParams.pageNum = this.currentPage;
            this.treatOrderParams.pageSize = this.pageNums;
            getTreatOrderAllList(this.treatOrderParams).then(response => {
                console.log(response);
                this.tableLoading = false;
                if (response.data.code === 200) {
                    this.totalCount = response.data.total;
                    this.tableData = response.data.rows;
                    this.treatItemData = response.data.rows.treatOrderItemList;
                    if (this.tableData.length > 0) {
                        this.tableData.forEach(item=>{
                            item.isExpandRow = false;
                            item.isExecutedNum = 0;
                            if (item.treatOrderItemList.length > 0) {
                                item.treatOrderItemList.forEach(itm=>{
                                    if (itm.excuteStatus === '1') {
                                        item.isExecutedNum++;
                                    }
                                })
                            }
                            if (item.isExecutedNum === item.treatOrderItemList.length) {
                                item.isExecutedInfo = '2';
                                item.orderStatus = '3';
                            } else if (item.isExecutedNum === 0) {
                                item.isExecutedInfo = '0';
                            } else {
                                item.isExecutedInfo = '1';
                            }

                            if (item.dppSex === "1") {
                                item.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                            } else if (item.dppSex === "0") {
                                item.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                            } else {
                                item.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                            }
                        })
                    }
                }
            });
        },


        // 打开详情展示弹窗
        expandRowDetail(items) {
            this.treatOrderDetailVisible = true;
            this.treatLoading = true;
            this.treatOrder = items;
            this.payCodeList = [];
            this.payCodeList.push(this.tencentCosUrl+items.payQrcode);
            this.treatOrderItem.treatId = items.id;
            getTreatOrderItemList(this.treatOrderItem).then(response => {
                console.log(response);
                this.treatLoading = false;
                this.treatItemData = [];
                if (response.data.code === 200) {
                    this.treatItemData = response.data.rows;
                }
            });
        },

        // 取消详情展示弹窗
        cancelTreatDetail() {
            this.treatOrderDetailVisible = false;
        },

        // 新增检查治疗项目
        openAddTreat() {
            this.addTreatVisible = true;
        },


        // 取消新增检查治疗项目
        cancelAddTreat() {
            this.addTreatVisible = false;
        },

        // 保存新增检查治疗项目
        saveAddTreat() {
            if (chackAlertMsg(this.treatOrder.projectType, '项目类型不能为空', 'error')
                && chackAlertMsg(this.treatOrderProjectName, '项目名称不能为空', 'error')) {
                console.log(this.treatOrderProjectName);
                let projectNameList =[];
                let treatOrderItemList =[];
                let treatPrice = 0;
                let orderPrice = 0;
                this.treatOrderProjectName.forEach(itemPro=>{
                    this.treatItemList.forEach(item=>{
                        if (itemPro === item.itemId) {
                            let treatOrderItem = {
                                treatId: item.itemId,
                                projectType: item.itemType,
                                projectName: item.itemName,
                                defaultPrice: item.itemDefaultPrice,
                                orderPrice: item.itemDefaultPrice,
                            }
                            treatPrice += item.itemDefaultPrice;
                            orderPrice += item.itemDefaultPrice;
                            treatOrderItemList.push(treatOrderItem);
                            projectNameList.push(item.itemName);
                        }
                    })
                })
                this.treatOrder.treatPrice = treatPrice;
                this.treatOrder.orderPrice = orderPrice;
                this.treatOrder.treatOrderItemList = treatOrderItemList;
                this.treatOrder.projectName = projectNameList.join(",");
                this.treatOrder.dppId = this.patientInfo.dppId;
                this.treatOrder.dppName = this.patientInfo.name;
                this.treatOrder.dppSex = this.patientInfo.sex;
                this.treatOrder.dppAge = this.patientInfo.age;
                this.treatOrder.dppPhone = this.patientInfo.phoneNumber;
                this.treatOrder.dppIdentity = this.patientInfo.identity;
                this.treatOrder.dppAllergyHistory = this.patientInfo.allergyHistory;

                addNewTreatOrder(this.treatOrder).then(response => {
                    console.log(response);
                    if (response.code === 200) {
                        this.addTreatVisible = false;
                        this.getTreatHistoryOrderList(); // 刷新表格数据
                    } else {
                        message(response.msg, "error");
                    }
                })
            }
        },



        // 保存检查治疗工单
        sureSaveTreatOrderFun() {
            if (chackAlertMsg(this.treatOrder.projectType, '项目类型不能为空', 'error')
                && chackAlertMsg(this.treatOrderProjectName, '项目名称不能为空', 'error')) {
                console.log(this.treatOrderProjectName);
                let projectNameList =[];
                let treatOrderItemList =[];
                let treatPrice = 0;
                let orderPrice = 0;
                this.treatOrderProjectName.forEach(itemPro=>{
                    this.treatItemList.forEach(item=>{
                        if (itemPro === item.itemId) {
                            let treatOrderItem = {
                                treatId: item.itemId,
                                projectType: item.itemType,
                                projectName: item.itemName,
                                defaultPrice: item.itemDefaultPrice,
                                orderPrice: item.itemDefaultPrice,
                            }
                            treatPrice += item.itemDefaultPrice;
                            orderPrice += item.itemDefaultPrice;
                            treatOrderItemList.push(treatOrderItem);
                            projectNameList.push(item.itemName);
                        }
                    })
                })
                this.treatOrder.treatPrice = treatPrice;
                this.treatOrder.orderPrice = orderPrice;
                this.treatOrder.treatOrderItemList = treatOrderItemList;
                this.treatOrder.projectName = projectNameList.join(",");
                this.treatOrder.dppName = this.patientInfo.name;
                this.treatOrder.dppSex = this.patientInfo.sex;
                this.treatOrder.dppAge = this.patientInfo.age;
                this.treatOrder.dppPhone = this.patientInfo.phoneNumber;
                this.treatOrder.dppIdentity = this.patientInfo.identity;
                this.treatOrder.dppAllergyHistory = this.patientInfo.allergyHistory;

                addNewTreatOrder(this.treatOrder).then(response => {
                    console.log(response);
                    if (response.code === 200) {
                        this.chooseDppId = this.treatOrder.dppId;
                        this.dppId = this.treatOrder.dppId;
                        this.openPatientDetail(this.dppId);
                        this.treatePage = "2";
                        this.getTreatHistoryOrderList(); // 刷新表格数据
                        this.resizeTableHeight(); // 表格高度自适应
                    } else {
                        message(response.msg, "error");
                    }
                })
            }
        },

    }
}